import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Button,
  Stack,
  CircularProgress,
  Modal,
} from "@mui/material";
import ScrollableTable from "./ScrollableTable";
import { useUser } from "../Contexts/UserContext";
import EnhancedTable from "./EnhancedTable";
import getTodayDate from "./TodaysDate";
import { ClassNames } from "@emotion/react";

const API_URL = process.env.REACT_APP_DOMAIN_API_URL;
const columns = [
  { id: "Empcode", label: "EmpCode", idx: 0 },
  { id: "EmpName", label: "EmpName", idx: 1 },
  { id: "LoginTime", label: "LOGINTIME", idx: 2 },
  { id: "LogoutTime", label: "LOGOUTTIME", idx: 3 },
];

const StatsCard2 = ({
  title,
  subtitle,
  number,
  number2,
  classNames,
  activeBtn,
}) => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [flipped, setFlipped] = useState(false);
  const [additionalData, setAdditionalData] = useState({
    LateLoginCount: 1,
    EarlyLogoutCount: 1,
  });
  const { user } = useUser();
  const { ClientId, CompCode } = user;
  useEffect(() => {
    const fetchInitData = async () => {
      const getAdditionalInfo = await fetch(
        `${API_URL}/facility/get-login-logout-times/3/${CompCode}/${ClientId}/UNTAPS009554/2/${getTodayDate()}/${getTodayDate()}`
      ).then((res) => res.json());
      // console.log("res", getAdditionalInfo);
      if (getAdditionalInfo.success)
        setAdditionalData(getAdditionalInfo.data[0]);
    };
    fetchInitData();
  }, [ClientId]);
  const handleOpen = (e) => {
    e.stopPropagation();
    setOpen(true);
    fetchData();
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      if (classNames === "c1") {
        const res = await fetch(
          `${API_URL}/facility/get-client-all-unit/1/${ClientId}/0`
        ).then((res) => res.json());
        setData(res.data.units);
      } else {
        const res = await fetch(
          `${API_URL}/facility/get-login-logout-times/1/${CompCode}/${ClientId}/UNTAPS009554/0/${getTodayDate()}/${getTodayDate()}`
        ).then((res) => res.json());
        setData(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setLoading(false);
  };

  return (
    <div
      className={`flip-card ${flipped ? "flipped" : ""}`}
      onClick={() => setFlipped(!flipped)}
    >
      <div className="flip-card-inner">
        <Card
          className="flip-card-front"
          sx={{
            minWidth: 200,
            width: 220,
            maxWidth: 250,
            boxShadow: 3,
            borderRadius: 2,
            border: "2px solid black",
            backgroundColor: "#1976d2",
          }}
        >
          <CardContent>
            <Typography
              sx={
                title.length < 15
                  ? {
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "500",
                      padding: "0",
                      lineHeight: "25px",
                      margin: "0px 0px 0px 0vw",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      fontFamily: "Poppins, sans-serif",
                    }
                  : {
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: "500",
                      padding: "0",
                      lineHeight: "25px",
                      margin: "0px 0px 0px 0vw",
                      letterSpacing: "2px",
                      textTransform: "uppercase",
                      fontFamily: "Poppins, sans-serif",
                    }
              }
              gutterBottom
            >
              {title}
            </Typography>
            <Typography variant="h3" component="div" sx={{ color: "#fff" }}>
              {classNames == "Attendance"
                ? `${number}/${number2}`
                : `${number}/${number2 * 10}`}
            </Typography>
            <Stack direction="row" spacing={1}>
              <Typography
                sx={{
                  color: "#b0bec5",
                  margin: "0px 0px 0px 0px",
                  fontWeight: "700",
                  fontSize: "14px",
                  fontFamily: "Share Tech Mono",
                  fontFamily: "monospace",
                }}
              >
                {subtitle}
              </Typography>
              {activeBtn && (
                <Button
                  size="small"
                  variant="outlined"
                  sx={{
                    height: "20px",
                    color: "#fff",
                    fontSize: "10px",
                    width: "auto",
                    marginRight: "10px",
                  }}
                  onClick={handleOpen}
                >
                  View
                </Button>
              )}
            </Stack>
          </CardContent>
        </Card>
        <Card
          className="flip-card-back"
          sx={{
            minWidth: 200,
            width: 220,
            maxWidth: 250,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#0d47a1",
            color: "#fff",
          }}
        >
          {/* {console.log(classNames)} */}
          {classNames === "Attendance" && (
            <>
              <CardContent>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "25px",
                    margin: "0px 0px 10px 0vw",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    fontFamily: "Poppins, sans-serif",
                  }}
                  gutterBottom
                >
                  Additional Info
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ marginBottom: "10px" }}
                >
                  LATE:{" "}
                  {/* {((additionalData.LateLoginCount * 100) / number).toFixed(2)}% */}
                  {console.log(additionalData.LateLoginCount)}
                  {additionalData.LateLoginCount === 0
                    ? `0`
                    : (
                        (additionalData.LateLoginCount * 100) /
                        parseInt(number, 10)
                      ).toFixed(2)}
                  %
                </Typography>
                <Typography component="div">
                  ON TIME:{" "}
                  {additionalData.LateLoginCount === 0
                    ? `100`
                    : (
                        ((parseInt(number, 10) -
                          additionalData.LateLoginCount) *
                          100) /
                        parseInt(number, 10)
                      ).toFixed(2)}
                  %
                </Typography>
              </CardContent>
            </>
          )}
          {classNames === "Washroom" && (
            <>
              <CardContent>
                <Typography
                  sx={{
                    fontSize: "16px",
                    fontWeight: "500",
                    padding: "0",
                    lineHeight: "25px",
                    margin: "0px 0px 10px 0vw",
                    letterSpacing: "1px",
                    textTransform: "uppercase",
                    fontFamily: "Poppins, sans-serif",
                  }}
                  gutterBottom
                >
                  Additional Info
                </Typography>
                <Typography
                  variant="h6"
                  component="div"
                  sx={{ marginBottom: "10px" }}
                >
                  {`Expected Reports: ${
                    (new Date().getHours() - 10) * number2
                  }  `}
                </Typography>
                {/* <Typography component="div">
                 
                </Typography> */}
              </CardContent>
            </>
          )}
        </Card>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box
          sx={{
            width: 800,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          {loading ? (
            <CircularProgress />
          ) : data ? (
            classNames === "c1" ? (
              <ScrollableTable data={data} />
            ) : (
              <EnhancedTable columns={columns} data={data} />
            )
          ) : (
            "No data available"
          )}
        </Box>
      </Modal>
    </div>
  );
};

export default StatsCard2;
